module.exports = __webpack_public_path__ + "img/domestic-1983-professional-paper.ed263d60.jpg";